import { render, staticRenderFns } from "./CoursePackageComponent.vue?vue&type=template&id=5c99b04f&scoped=true"
import script from "./CoursePackageComponent.vue?vue&type=script&lang=js"
export * from "./CoursePackageComponent.vue?vue&type=script&lang=js"
import style0 from "./CoursePackageComponent.vue?vue&type=style&index=0&id=5c99b04f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99b04f",
  null
  
)

export default component.exports